/**
 * collection-filters.js — Studio 1/1
 * Shopify collection filter + sort — AJAX progressive enhancement.
 *
 * The prototype's filter sidebar has no "Apply" button and no mobile
 * drawer/toggle — checkboxes and the sort <select> just work in place.
 * This mirrors that: any [data-auto-submit] input or the sort <select>
 * submits the form on change; the grid + pagination + count swap in via
 * fetch.
 *
 * Hooks consumed (see main-collection.liquid):
 *   [data-collection-form]    — filter + sort <form>
 *   [data-collection-results] — wraps the grid AND its pagination <nav>;
 *                                swapped as one unit so "Next"/"Prev"
 *                                links always reflect the currently
 *                                active filters instead of the stale
 *                                links from the last full page load.
 *   [data-product-grid]       — <ul> of product cards (inside the above)
 *   [data-filter-count]       — product count paragraph (aria-live)
 *   [data-sort-select]        — sort <select>
 *   [data-auto-submit]        — filter checkbox/radio that submits on change
 *
 * Graceful degradation: without fetch/JS, all of this still works via a
 * plain <form method="GET"> full-page load.
 */

(() => {
  'use strict';

  var form = document.querySelector('[data-collection-form]');
  if (!form) return;

  function fetchFilteredPage(url) {
    var results = document.querySelector('[data-collection-results]');
    var counter = document.querySelector('[data-filter-count]');
    if (!results) return;
    results.setAttribute('aria-busy', 'true');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newResults = doc.querySelector('[data-collection-results]');
        if (newResults && results) {
          results.outerHTML = newResults.outerHTML;
          results = document.querySelector('[data-collection-results]');
          results.removeAttribute('aria-busy');
        }

        var newCount = doc.querySelector('[data-filter-count]');
        if (counter && newCount) counter.textContent = newCount.textContent;

        window.history.pushState({ path: url }, '', url);
      })
      .catch(function () {
        window.location.assign(url);
      });
  }

  function submitForm() {
    if (!window.fetch) { form.submit(); return; }
    var params = new URLSearchParams(new FormData(form));
    params.delete('page');
    fetchFilteredPage(form.action + '?' + params.toString());
  }

  form.addEventListener('submit', function (e) {
    if (!window.fetch) return;
    e.preventDefault();
    submitForm();
  });

  form.querySelectorAll('[data-auto-submit]').forEach(function (input) {
    input.addEventListener('change', submitForm);
  });

  var sortSel = form.querySelector('[data-sort-select]');
  if (sortSel) sortSel.addEventListener('change', submitForm);

  window.addEventListener('popstate', function () {
    fetchFilteredPage(window.location.href);
  });
})();
